/**
 * Footer — Site footer with nav links and contact info.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div>
          <div className={styles.brand}>Fairfax Roarbotics</div>
          <p className={styles.tagline}>
            Fairfax High School&apos;s FIRST Tech Challenge team — designing,
            building, and competing since 2019.
          </p>
        </div>

        <div>
          <div className={styles.heading}>Navigate</div>
          <ul className={styles.links}>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/robot">Robot</Link></li>
            <li><Link to="/sponsors">Sponsors</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/join">Join</Link></li>
          </ul>
        </div>

        <div>
          <div className={styles.heading}>Reach us</div>
          <ul className={styles.links}>
            <li>
              <a href="mailto:ffxrobotics@gmail.com">ffxrobotics@gmail.com</a>
            </li>
            <li>3501 Lion Run, Fairfax, VA 22030</li>
          </ul>
        </div>
      </div>

      <div className={styles.bottom}>
        <span>
          © {new Date().getFullYear()} Fairfax Roarbotics · FIRST Tech Challenge Team
        </span>
        <span className={styles.credit}>
          Site designed by{' '}
          <a
            href="https://aelio.dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aelio
          </a>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
